import type { SharePrepareResponse } from '@penalty-cup/shared';
import { openTelegramLink, shareMessage } from '@tma.js/sdk-react';

/**
 * Родной диалог Telegram «поделиться» (Bot API 8.0+). Старый клиент или ошибка — запасной путь:
 * t.me/share/url с текстом и ссылкой «играть».
 */
export async function openShareDialog(prepared: SharePrepareResponse): Promise<void> {
  try {
    if (shareMessage.isAvailable()) {
      await shareMessage(prepared.preparedMessageId);
      return;
    }
  } catch {
    // пользователь закрыл диалог или метод не поддержан — пробуем запасной путь ниже
    return;
  }
  const url = `https://t.me/share/url?url=${encodeURIComponent(prepared.link)}&text=${encodeURIComponent(prepared.text)}`;
  if (openTelegramLink.isAvailable()) openTelegramLink(url);
  else window.open(url, '_blank', 'noopener');
}
